import Reveal from "@/components/Reveal";

const ChapterHeading = ({ num, eyebrow, title, sub, testid }) => (
  <Reveal data-testid={testid} className="mb-12 sm:mb-16">
    <div className="flex items-end gap-5 sm:gap-8">
      <span className="text-stroke-faint font-display text-5xl font-extrabold leading-none sm:text-7xl" aria-hidden="true">
        {num}
      </span>
      <div className="min-w-0 flex-1 pb-1">
        <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-zinc-500">{eyebrow}</p>
        <h2 className="mt-2 font-display text-2xl font-extrabold uppercase tracking-tight text-offwhite sm:text-3xl lg:text-4xl">
          {title}
        </h2>
        {sub && <p className="mt-3 max-w-xl text-sm leading-relaxed text-zinc-400 sm:text-base">{sub}</p>}
      </div>
    </div>
    <div className="mt-8 h-px w-full bg-gradient-to-r from-silver/40 via-white/10 to-transparent" />
  </Reveal>
);

export default ChapterHeading;
